import { Component, OnInit, Input, Output, EventEmitter, OnChanges, HostListener,  ElementRef, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { VehicleFilterService } from '../../shared/services/vehicle-filter.service';

@Component({
    selector   : 'nw-sidebar',
    templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit, OnChanges {
    @Input() filterOptionData: Observable<Array<any>> = Observable.of([]);
    @Input() screenSize = 'lg';
    @Input() isSideBarOpen : boolean;
    @Output() filterHandler: EventEmitter<any> = new EventEmitter();
    @Output() closeMobileFilterEvent: EventEmitter<any> = new EventEmitter();
    @Output() ifAnyCategorySelected: EventEmitter<boolean> = new EventEmitter();
    filterStore = new BehaviorSubject([]);

    model: Array<any> = [];
    selectedFilterObj = [];
    selectedFilter = [];
    ifAnyCategorySelectedMobileView = false;
    sidebarAccordionGroup: string = 'sidebar-accordion-group';
    ifOnMobileSelectedCategory: boolean = false;
    ifShowAllICategorytemsMobileView: boolean = false;
    mobileItemsCategoryDefaultLength: number = 4;

    constructor(private vehicleFilterService: VehicleFilterService) {
    }

    ngOnInit() {
        this.filterOptionData.subscribe((resp) => {
            this.updateModel(resp);
        });
    }

    ngOnChanges() {
        this.vehicleFilterService.ifClearAllCategories
            .subscribe(val => {
                if(val) {this.clearAllCategories();}
            });
        this.vehicleFilterService.ifMobileSidebarToOpen
            .subscribe(val => {
                if(val) {this.isSideBarOpen = true;}
            });
    }

    updateModel(response) {

        if(response.length > 0) {
            if(this.model.length === 0) {
                Object.assign(this.model, response);
            } else {
                Object.assign(this.model, response.map(resData => {
                    let refreshedModel = Object.assign(this.model.filter(data => data.category === resData.category)[0], resData);
                    return refreshedModel;
                }));
            }

            this.model.map((item) => {
                item['checkedCategory'] = false;
                for (const bucket of item.buckets) {
                    bucket.checked =
                        (this.selectedFilterObj[item.category] !== undefined && this.selectedFilterObj[item.category].indexOf(bucket.value) > -1)
                            ? true : false;
                    item['checkedCategory'] = item['checkedCategory'] || bucket.checked;
                }
            });
            this.filterStore.next(this.model);
        }
    }

    apply() {
        let filterModel = [];
        this.selectedFilter = [];
        let ifAnyCategorySelectedFlag = false;

        this.model.map((item) => {

            // let filterItem = item;
            let filterBuckets = [];

            item.buckets.map(bucket => {
                if(bucket['checked'] === true) {
                    filterBuckets.push(bucket);
                    ifAnyCategorySelectedFlag = true;
                }
                return bucket;
            });
            filterModel.push({
                category: item.category,
                buckets: filterBuckets
            });

            // update local states
            this.selectedFilterObj[item.category] = [];
            filterBuckets.map((bucket) => {

                this.selectedFilterObj[item.category].push(bucket.value);
            });

            return item;
        });
        this.ifAnyCategorySelectedMobileView = ifAnyCategorySelectedFlag;
        this.filterHandler.emit(filterModel);
        this.ifAnyCategorySelected.emit(ifAnyCategorySelectedFlag);
    }

    isDate(date): boolean {
        return (String(new Date(date)) !== 'Invalid Date') && Number.isInteger(date) ? true : false;
    }

    stopClosingMenu($event) {

        $event.stopPropagation();

    }

    closeFilter() {
        this.isSideBarOpen =!this.isSideBarOpen;
    }

    clearCategory(category) {
        this.model.map((item) => {
            if(item.category === category) {
                item.checkedCategory = false;
                this.selectedFilterObj[item.category] = [];
                item.buckets.map(bucket => {
                    bucket.checked = false;
                });
            }
            return item;
        });
        this.apply();
    }

    clearOpenCategoryOnMobile() {
        if(['xs', 'sm'].indexOf(this.screenSize) > -1 && this.components && this.components['_results']) {
            this.components['_results'].map((result, index) => {
                if (result['_isOpen'] === true) {
                    this.clearCategory(this.model[index]["category"]);
                }
            });
        }
    }

    clearAllCategories() {
        this.model.map((item) => {
                item.checkedCategory = false;
                this.selectedFilterObj[item.category] = [];
                item.buckets.map(bucket => {
                    bucket.checked = false;
                });
            return item;
        });
        this.apply();
    }

    closeAllCategories() {
        if(this.components['_results'] && this.components) {
            this.components['_results'].map((result, index) => {
                result['_isOpen'] = false;
                return this.model[index]['isOpen'] = false;
            });
        }
        this.ifShowAllICategorytemsMobileView = false;
        this.ifOnMobileSelectedCategory = false;
        this.filterStore.next(this.model);
    }

    showAllMobileMenuOptionsCategory() {
        this.ifShowAllICategorytemsMobileView = true;
    }

    @ViewChildren('accordionGroupElement') components:QueryList<any>;

    @HostListener('click', ['$event']) clickHandler(event) {
        this.ifOnMobileSelectedCategory = false;
        if(this.components['_results'] && this.components) {
            this.components['_results'].map((result, index) => {
                if(['xs', 'sm'].indexOf(this.screenSize) > -1 && result['_isOpen']) {
                    this.ifShowAllICategorytemsMobileView = !(this.model[index].buckets.length > this.mobileItemsCategoryDefaultLength) || this.ifShowAllICategorytemsMobileView;
                    this.ifOnMobileSelectedCategory = true;
                }
                return this.model[index]['isOpen'] = result['_isOpen'];
            });
        }
        if(['xs', 'sm'].indexOf(this.screenSize) > -1) {

        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/sidebar/sidebar.component.ts